export default __webpack_public_path__ + "static/media/type_3_5.4fa16621.svg";